import React from "react";
import { Box } from "@material-ui/core";
import clsx from "clsx";
import dayjs from "dayjs";
import { useHistory } from "react-router";
import {
  DefaultImageBanner,
  LUX_Q2_VR_OFFER_PLACEMENT_IMAGE,
  useDeviceTypes,
  SanitizedHtml,
} from "halifax";
import {
  appendIsTravelAppParam,
  PATH_PREMIUM_STAYS_VR,
  PATH_TERMS_LUX_Q2_VR_OFFER,
  useIsTravelApp,
} from "@capone/common";
import { InView } from "react-intersection-observer";
import { TravelWalletOffer } from "redmond";
import { trackEvent } from "../../../../api/v0/analytics/trackEvent";
import { useQ2VROffer } from "../../../../hooks/useQ2VROffer";
import "./styles.scss";

const VIEWED_LUXURY_OFFER_PROMOTION_BANNER =
  "viewed_luxury_offer_promotion_banner";
const CLICKED_LUXURY_OFFER_PROMOTION_CTA =
  "clicked_luxury_offer_promotion_cta";
const ENTRY_POINT = "premium_stays_landing";

export interface LuxQ2VROfferBannerProps {
  travelWalletOffers: TravelWalletOffer[];
}

export const LuxQ2VROfferBanner = ({
  travelWalletOffers,
}: LuxQ2VROfferBannerProps): JSX.Element | null => {
  const offer = useQ2VROffer(travelWalletOffers);
  const history = useHistory();
  const { isTravelApp } = useIsTravelApp();
  const { matchesMobile } = useDeviceTypes();

  if (!offer) {
    return null;
  }

  return (
    <InView
      as="div"
      triggerOnce
      threshold={0.5}
      onChange={(inView) => {
        if (inView) {
          trackEvent({
            eventName: VIEWED_LUXURY_OFFER_PROMOTION_BANNER,
            properties: {
              entry_point: ENTRY_POINT,
              offer_id: offer.id,
            },
            encryptedProperties: [
              offer.trackingPropertiesV2?.encryptedProperties ?? "",
            ],
          });
        }
      }}
    >
      <Box
        className={clsx(
          "luxury-promotion-banner-container",
          "lux-q2-vr-offer-banner",
          { mobile: matchesMobile },
        )}
      >
        <DefaultImageBanner
          imageUrl={LUX_Q2_VR_OFFER_PLACEMENT_IMAGE}
          // eslint-disable-next-line react/no-danger
          title={<SanitizedHtml as="span" html={offer.title} />}
          description={offer.descriptions[0] || ""}
          buttonText="Book now"
          buttonAction={() => {
            trackEvent({
              eventName: CLICKED_LUXURY_OFFER_PROMOTION_CTA,
              properties: {
                entry_point: ENTRY_POINT,
                offer_id: offer.id,
              },
              encryptedProperties: [
                offer.trackingPropertiesV2?.encryptedProperties ?? "",
              ],
            });
            window.scrollTo(0, 0);
            history.push(
              appendIsTravelAppParam(PATH_PREMIUM_STAYS_VR, isTravelApp),
            );
          }}
          termsAndConditionsUrl={PATH_TERMS_LUX_Q2_VR_OFFER}
          termsAndConditionsSuffix={`| Expires on ${dayjs(
            offer.expiresOn,
          ).format("MMMM D, YYYY")}`}
        />
      </Box>
    </InView>
  );
};
